export const checkObjExist = (id, arr, type) => {
    const current = arr?.find(o => id === o.id);
    if(current) return current;
    else return false

  };